import React from 'react';
import type { Grade } from '../../types';

const GRADE_STYLES: Record<Grade, string> = {
  A: 'bg-secondary/10 dark:bg-secondary/20 text-secondary dark:text-secondary border-secondary/20 dark:border-secondary/40',
  B: 'bg-primary/10 dark:bg-primary/20 text-primary dark:text-primary border-primary/20 dark:border-primary/40',
  C: 'bg-tertiary/10 dark:bg-tertiary/20 text-tertiary dark:text-tertiary border-tertiary/20 dark:border-tertiary/40',
  D: 'bg-orange-50 dark:bg-orange-900/20 text-orange-500 dark:text-orange-400 border-orange-200 dark:border-orange-800/40',
  F: 'bg-error/10 dark:bg-error/20 text-error dark:text-error border-error/20 dark:border-error/40',
};

interface GradeBadgeProps {
  grade: Grade;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE_MAP = {
  sm: 'px-2 py-0.5 text-sm',
  md: 'px-3 py-1 text-lg',
  lg: 'px-4 py-2 text-2xl',
};

const GradeBadge: React.FC<GradeBadgeProps> = ({ grade, size = 'md', className = '' }) => (
  <span className={`inline-block border font-headline ${GRADE_STYLES[grade]} ${SIZE_MAP[size]} ${className}`}>
    {grade}
  </span>
);

export default GradeBadge;
